export default __webpack_public_path__ + "static/media/mongodb.d89a6eebb2b81e487ffc99f69a3f6ea4.svg";